import cx from 'classnames';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  getDocument,
  getIsDocumentRequester,
  getParticipants,
  getSigningProgressSignerAttachments,
} from '@app/store/signingProgressInformation/selectors';

import SignatureProgressAttachmentsInfo from '../AttachmentsInfo';
import SignatureProgressCarbonCopies from '../CarbonCopies';
import SignatureProgressDocumentInfo from '../DocumentInfo';
import SignatureProgressParticipatorsInfo from '../ParticipantsInfo';
import SignatureProgressRequesterInfo from '../RequesterInfo';

import './SignatureInformation.scss';

interface SignatureInformationProps {
  active: boolean;
}

function SignatureInformation({ active }: SignatureInformationProps) {
  const participants = useSelector(getParticipants);
  const document = useSelector(getDocument);
  const signerAttachments = useSelector(getSigningProgressSignerAttachments);

  const hasAttachments = signerAttachments.length > 0;

  const isSigningInOrder = useMemo(() => {
    return !participants.every((participant) => participant.signingOrder === 1);
  }, [participants]);

  const isDocumentRequester = useSelector(getIsDocumentRequester);

  return (
    <div
      className={cx({
        SignatureInformation: true,
        'SignatureInformation--active': active,
      })}
    >
      <SignatureProgressDocumentInfo />
      <hr className="Line SignatureInformation__line" />
      <SignatureProgressRequesterInfo />
      <hr className="Line SignatureInformation__line" />
      <SignatureProgressParticipatorsInfo />
      {isDocumentRequester && document.carbonCopies.length > 0 && (
        <>
          <hr className="Line SignatureInformation__line" />
          <SignatureProgressCarbonCopies />
        </>
      )}
      {hasAttachments && (
        <>
          <hr className="Line SignatureInformation__line" />
          <SignatureProgressAttachmentsInfo
            attachments={signerAttachments}
            isSigningInOrder={isSigningInOrder}
          />
        </>
      )}
    </div>
  );
}

export default SignatureInformation;
